export default function ScoreInput({ value, onChange, disabled = false }) {
  return (
    <input
      type="number"
      min="0"
      max="99"
      maxLength="2"
      value={value === null ? '' : value}
      className={`score-input ${disabled ? 'score-input--disabled' : ''}`}
      onChange={onChange}
      disabled={disabled}
      onFocus={(e) => !disabled && e.target.select()}
      onKeyDown={(e) => {
        if (e.key >= '0' && e.key <= '9' && e.target.value === '0') {
          e.target.select();
        }
      }}
      onInput={(e) => {
        if (e.target.value.length > 2) e.target.value = e.target.value.slice(0, 2);
      }}
    />
  );
}